export const paiseToRupees = (paise) => Number((paise || 0) / 100);

export const formatRupees = (paise) => {
  const rupees = paiseToRupees(paise);
  return `₹${rupees.toLocaleString("en-IN", {
    minimumFractionDigits: rupees % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};
